module.exports = __webpack_public_path__ + "e789a7414219c5a485333dd8bb0581ee.svg";